var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandelsbankenlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 82.073997,
    viewBox: "0 0 800 82.074",
    id: "Lager_1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.818,44.401 L 16.818,80.505 L 0,80.505 L 0,0 L 16.818,0 L 16.818,30.498 L 48.213,30.498 L 48.213,0 L 65.032,0 L 65.032,80.505 L 48.213,80.505 L 48.213,44.401 L 16.818,44.401 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 127.483,68.844 C 127.483,75.908 129.053,77.479 130.959,78.151 L 130.959,80.505 L 114.028,80.505 C 113.131,77.701 112.907,76.805 112.57,73.442 C 108.982,77.141 103.937,82.075 93.285,82.075 C 84.315,82.075 75.121,77.03 75.121,64.696 C 75.121,53.036 82.521,47.092 92.5,45.635 L 106.627,43.504 C 109.094,43.168 112.121,42.159 112.121,38.795 C 112.121,32.18 105.842,31.844 101.806,31.844 C 93.957,31.844 92.612,36.665 92.163,40.141 L 77.027,40.141 C 78.821,21.865 91.491,19.286 103.713,19.286 C 112.122,19.286 127.483,21.865 127.483,36.553 L 127.483,68.844 L 127.483,68.844 z M 112.122,51.465 C 110.552,52.698 107.974,53.707 101.47,54.716 C 95.639,55.726 90.818,57.184 90.818,63.687 C 90.818,69.18 95.079,70.863 98.107,70.863 C 105.058,70.863 112.122,66.379 112.122,59.091 L 112.122,51.465 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 194.309,80.505 L 178.612,80.505 L 178.612,44.288 C 178.612,39.916 178.388,32.516 168.409,32.516 C 161.457,32.516 156.076,37.225 156.076,46.308 L 156.076,80.505 L 140.379,80.505 L 140.379,20.855 L 155.403,20.855 L 155.403,29.601 L 155.628,29.601 C 157.758,26.013 162.243,19.285 173.567,19.285 C 185.228,19.285 194.31,26.125 194.31,39.243 L 194.31,80.505 L 194.309,80.505 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 262.255,80.505 L 246.894,80.505 L 246.894,72.992 L 246.67,72.992 C 242.858,79.721 235.906,82.074 229.403,82.074 C 211.687,82.074 204.287,66.378 204.287,50.007 C 204.287,29.377 215.948,19.285 229.066,19.285 C 239.157,19.285 243.866,24.78 246.334,28.591 L 246.558,28.591 L 246.558,0 L 262.256,0 L 262.256,80.505 L 262.255,80.505 z M 233.327,69.18 C 243.306,69.18 247.23,60.883 247.23,52.026 C 247.23,42.496 244.539,32.853 233.775,32.853 C 223.796,32.853 220.432,41.711 220.432,51.13 C 220.433,58.192 223.236,69.18 233.327,69.18 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 326.39,63.014 C 322.242,77.366 310.356,82.075 300.153,82.075 C 283.335,82.075 270.441,74.003 270.441,49.448 C 270.441,42.271 272.907,19.286 299.032,19.286 C 310.805,19.286 327.063,24.892 327.063,52.139 L 327.063,54.942 L 286.138,54.942 C 286.587,59.427 287.484,69.519 300.154,69.519 C 304.527,69.519 309.012,67.276 310.245,63.015 L 326.39,63.015 L 326.39,63.014 z M 310.917,44.737 C 310.02,35.094 303.853,32.179 298.808,32.179 C 291.408,32.179 287.483,36.888 286.586,44.737 L 310.917,44.737 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 352.515,80.505 L 336.818,80.505 L 336.818,0 L 352.515,0 L 352.515,80.505 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 400.168,39.019 C 399.495,35.207 398.148,31.171 389.627,31.171 C 381.106,31.171 379.984,34.422 379.984,37.001 C 379.984,46.419 417.321,39.58 417.321,61.557 C 417.321,78.935 400.504,82.075 391.197,82.075 C 377.63,82.075 362.942,77.366 362.493,61.444 L 378.639,61.444 C 378.639,66.49 381.779,70.19 391.646,70.19 C 399.718,70.19 401.625,66.265 401.625,64.023 C 401.625,54.044 364.624,61.557 364.624,39.244 C 364.624,30.498 370.118,19.286 388.73,19.286 C 400.39,19.286 414.294,22.201 415.528,39.02 L 400.168,39.02 L 400.168,39.019 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 442.887,28.591 L 443.111,28.591 C 445.578,24.779 450.288,19.285 460.378,19.285 C 473.497,19.285 485.158,29.376 485.158,50.007 C 485.158,66.378 477.758,82.074 460.042,82.074 C 453.539,82.074 446.587,79.72 442.775,72.992 L 442.551,72.992 L 442.551,80.505 L 427.189,80.505 L 427.189,0 L 442.887,0 L 442.887,28.591 z M 455.669,32.852 C 444.904,32.852 442.214,42.495 442.214,52.025 C 442.214,60.882 446.138,69.179 456.117,69.179 C 466.208,69.179 469.012,58.192 469.012,51.128 C 469.012,41.71 465.647,32.852 455.669,32.852 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 543.349,68.844 C 543.349,75.908 544.918,77.479 546.825,78.151 L 546.825,80.505 L 529.894,80.505 C 528.998,77.701 528.773,76.805 528.436,73.442 C 524.848,77.141 519.803,82.075 509.152,82.075 C 500.182,82.075 490.988,77.03 490.988,64.696 C 490.988,53.036 498.387,47.092 508.366,45.635 L 522.495,43.504 C 524.961,43.168 527.988,42.159 527.988,38.795 C 527.988,32.18 521.709,31.844 517.674,31.844 C 509.824,31.844 508.48,36.665 508.03,40.141 L 492.893,40.141 C 494.688,21.865 507.357,19.286 519.58,19.286 C 527.988,19.286 543.35,21.865 543.35,36.553 L 543.35,68.844 L 543.349,68.844 z M 527.987,51.465 C 526.418,52.698 523.839,53.707 517.336,54.716 C 511.505,55.726 506.684,57.184 506.684,63.687 C 506.684,69.18 510.946,70.863 513.973,70.863 C 520.924,70.863 527.988,66.379 527.988,59.091 L 527.988,51.465 L 527.987,51.465 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 610.175,80.505 L 594.478,80.505 L 594.478,44.288 C 594.478,39.916 594.253,32.516 584.275,32.516 C 577.323,32.516 571.941,37.225 571.941,46.308 L 571.941,80.505 L 556.244,80.505 L 556.244,20.855 L 571.268,20.855 L 571.268,29.601 L 571.493,29.601 C 573.623,26.013 578.107,19.285 589.432,19.285 C 601.092,19.285 610.175,26.125 610.175,39.243 L 610.175,80.505 L 610.175,80.505 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 639.774,80.505 L 624.077,80.505 L 624.077,0 L 639.774,0 L 639.774,43.504 L 659.507,20.855 L 678.793,20.855 L 657.713,43.952 L 679.353,80.505 L 660.517,80.505 L 646.278,54.94 L 639.774,61.668 L 639.774,80.505 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 736.089,63.014 C 731.941,77.366 720.056,82.075 709.852,82.075 C 693.034,82.075 680.14,74.003 680.14,49.448 C 680.14,42.271 682.607,19.286 708.732,19.286 C 720.504,19.286 736.763,24.892 736.763,52.139 L 736.763,54.942 L 695.836,54.942 C 696.285,59.427 697.182,69.519 709.852,69.519 C 714.225,69.519 718.71,67.276 719.944,63.015 L 736.089,63.015 L 736.089,63.014 z M 720.616,44.737 C 719.719,35.094 713.553,32.179 708.507,32.179 C 701.107,32.179 697.182,36.888 696.285,44.737 L 720.616,44.737 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 800,80.505 L 784.303,80.505 L 784.303,44.288 C 784.303,39.916 784.078,32.516 774.1,32.516 C 767.148,32.516 761.766,37.225 761.766,46.308 L 761.766,80.505 L 746.069,80.505 L 746.069,20.855 L 761.093,20.855 L 761.093,29.601 L 761.318,29.601 C 763.448,26.013 767.932,19.285 779.257,19.285 C 790.918,19.285 800,26.125 800,39.243 L 800,80.505 L 800,80.505 z ",
    style: {
      fill: "#003399",
      fillOpacity: 1
    },
    id: "path29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandelsbankenlogo);
export default __webpack_public_path__ + "static/media/handelsbankenlogo.1c3f887cf06d0024f3e70d7a03ad689f.svg";
export { ForwardRef as ReactComponent };